export default "/fonts/TiemposHeadline-Medium.woff?8a9585ce947d6e2d615b084e7140cce5";